import { PropertyType } from '../../../common';

export const mapApiToEntity = (data: PropertyType): PropertyType => {
	return {
		player: data.data,
	};
};

export const mapEntityToApi = (data: PropertyType): PropertyType => ({
	sid: data.token,
	player_id: data.id,
});
